import beijing from '@/charts/geo/beijing.js'
export default {
    beijing,
}


// WEBPACK FOOTER //
// ./src/model/chartMap.js